<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>

		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;`">
				<div class="container">
					<h2 class="text-white"></h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>

		<div class="container">
			<a-spin :spinning="loading">
				<div class='card card-1'>
					<!-- 动态 -->
					<div class="active-box">
						<div class="flex justify-between">
							<newsSwiper v-if="newsSwiper.length > 0" :list="newsSwiper" :type="1" width="534px" height="402px" radius="8px"></newsSwiper>
							<div class="news-list">
								<a-tabs v-model="currentTab" type="card" @change="tabChange" @tabClick="toNewsList"
									ref="tabs">
									<a-tab-pane v-for="(item,index) in newsList" :key="index"
										:tab="item.newsType.newsType">
										<div style="margin-top:-15px;">
											<div class="news-item flex justify-between"
												v-for="(news,newsIndex) in item.pageList.records"
												v-if="item.pageList.records!=''">
												<router-link class="w-300 line-1"
													:to="{path:'/news/info',query:{newsId:news.id}}">
													· {{news.newsTitle}}
												</router-link>
												<span>{{news.releaseTime}}</span>
											</div>
											<div v-if="item.pageList.records==''" class="padding-top-15">
												<a-empty style="padding:50px;" description="暂无新闻数据" />
											</div>
										</div>
									</a-tab-pane>
								</a-tabs>
							</div>
						</div>
					</div>
				</div>
			</a-spin>


			<!-- 项目公告 -->
			<div class="card margin-top-15 margin-bottom-15">
				<div class="card-head flex align-center">
					<div class="line"></div>
					<div class="font-24 margin-left-5">项目公告</div>
					<div class="tabs">
						<div class="item" @click="contentTabChange(index)" :class="contentTabIndex==index?'active':''"
							v-for="(item,index) in financeType">{{item.text}}</div>
					</div>
				</div>
				<div class="card-body">
					<table class="table">
						<thead>
							<tr>
								<th width="680">公示项目</th>
<!--								<th>公示时间</th>-->
								<th>发布时间</th>
<!--								<th>公示状态</th>-->
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item,index) in financeNewsList.records">
								<td class="line-1">
									<router-link style="color: #333;" :to="{path:'/news/info',query:{newsId:item.id}}">
										{{item.newsTitle}}
									</router-link>
								</td>
<!--								<td style="text-align: center;">{{item.beginTime==null?'':item.beginTime.substr(0,10)}} - {{item.endTime==null?'':item.endTime.substr(0,10)}}</td>-->
								<td style="text-align: center;">{{item.releaseTime}}</td>
<!--								<td style="text-align: center;">{{item.status==1?"未开始":''}}{{item.status==2?"进行中":''}}{{item.status==3?"已完成":''}}</td>-->

              </tr>
						</tbody>
					</table>
					<div class="flex justify-center margin-top-30">
						<a-pagination v-model:current="page" @change="pageChange" :total="financeNewsList.total" show-less-items />
					</div>
				</div>
			</div>


			<!-- 竞价大厅 -->
			<div class="card margin-top-15 margin-bottom-15">
				<div class="card-head flex align-center">
					<div class="line"></div>
					<div class="font-24 margin-left-5">竞价大厅</div>
				</div>
				<div class="card-body margin-top-15">
					<iframe width="1135" height="310" src="https://bid.ejy365.com/board/boardListStaticGX?org=6bc36947fa5311eb9c8d005056b7136c" frameborder="0"></iframe>
				</div>
			</div>
		</div>

		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	import newsSwiper from "@/components/NewsSwiper"
	export default {
		components: {
			BaseNav,
			BaseFooter,
			newsSwiper
		},
		data() {
			return {
				menuPosition: "1492378541355991041",
				headBg: "",
				currentTab: 0,
				contentTabIndex: 0,
				contentTabs: [],
				newsSwiper: [],
				newsList: [],
				financeType:[{text:"全部",value:""}],
				financeNewsList:{},
				loading: true,
				page:1,
			}
		},
		mounted() {
			let that = this;
			document.title = "雄安股权交易所-金融产权";
			// this.menuPosition = this.$route.query.menuPosition;
			this.getHeadBanner();
			this.getRecommendNews();
			this.queryFinanceType();
			this.getNews();
			setTimeout(() => {
				this.$nextTick(() => {
					var target = document.getElementsByClassName("ant-tabs-tab");
					for (let i = 0; i < target.length; i++) {
						target[i].addEventListener("mouseenter", (e) => {
							that.currentTab = i;
						})
					}
				})
			}, 1000)
		},
		methods: {
			//推荐新闻（轮播图）
			getRecommendNews() {
				this.$request({
					url: this.$api.home.getHomeRecommendNews,
					data: {
						menuId: this.menuPosition,
						type: 1
					},
				}).then((res) => {
					this.newsSwiper = res.data.result;
				})
			},
			getHeadBanner(){
				this.$request({
					url:this.$api.public.getBanner,
					data:{
						menuPosition:this.menuPosition,
						type:1
					}
				}).then((res)=>{
					this.headBg = this.$api.baseUrl+this.$api.imgPath+res.data.result[0].pcImageUrl;
				})
			},
			getNews() {
				this.$request({
					url: this.$api.home.getHomeNews,
					data: {
						menuId: this.menuPosition,
						pageSize: 6
					},
				}).then((res) => {
					this.newsList = res.data.result.slice(0, 3);
					this.contentTabs = res.data.result.slice(3, res.data.result.length);
					this.loading = false;

				})
			},
			pageChange(page){
				this.page = page;
				this.queryNewsListByTypeId();
			},
			//获取金融资产分类
			queryFinanceType(){
				this.$request({
					url:this.$api.news.queryFinanceType,
				}).then((res)=>{
					res.data.result.forEach((item)=>{
						this.financeType.push(item);
					})

					this.queryNewsListByTypeId();
				})
			},
			queryNewsListByTypeId(){
				this.$request({
					url:this.$api.news.queryNewsListByTypeId,
					data:{
						newsTypeId:this.financeType[this.contentTabIndex].value,
						pageNo:this.page,
					}
				}).then((res)=>{
					this.financeNewsList = res.data.result;
				})
			},
			// tab切换事件
			tabChange() {

			},
			contentTabChange(index) {
				this.contentTabIndex = index;
				this.queryNewsListByTypeId();
			},
			toNewsList(index) {
				let news = this.newsList[index].newsType;
				this.$router.push({
					path: "/news/list",
					query: {
						homeMenuFirstId: news.homeMenuFirstId,
						menuPosition: this.menuPosition,
						newsType: news.id
					}
				})
				// window.location.href = "http://www.baidu.com";
			},
			tabMouseEnter(e) {
				console.log(e)
			},
		}
	}
</script>

<style scoped="scoped">
	.tabs {
		display: flex;
		margin-left: 32px;
	}


	.tabs .item {
		font-size: 16px;
		color: #666;
		margin-right: 12px;
		cursor: pointer;
		padding: 8px 24px;
		border-radius: 8px;
	}

	.tabs .active {
		background-color: #13B8EE;
		color: white;
	}

	.bg-gray {
		background: #F6F7FC;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 142px;
	}

	.head-bg p {
		font-size: 24px;
	}

	.card {
		padding: 20px;
		background-color: #FFFFFF;
		border-radius: 8px;
	}

	.card-body {}

	.card-1 {
		/* margin-top: -50px; */
		margin-top: 40px;
	}

	.active-box {}

	.line {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.news-list {
		width: 600px;
	}

	.news-list .news-item {
		padding: 20px 15px;
		border-bottom: 1px solid #E6E6E6;
		font-size: 16px;
		transition: all 0.3s;
	}

	.news-list .news-item:nth-of-type(1) a {
		font-size: 18px;
		font-weight: bold;
		color: #13B8EE;
	}

	.news-list .news-item:nth-of-type(1):hover a {
		color: #13B8EE;
	}

	.news-list .news-item:hover {
		border-bottom: 1px dotted #13B8EE;
	}

	.news-list .news-item:hover a {
		color: #13B8EE;
	}

	.news-list .news-item a {
		color: #1A1A1A;
	}

	.table {
		margin-top: 32px;
		width: 100%;
		table-layout: fixed;
	}

	.table thead {
		background: rgba(30, 34, 170, 0.1);
	}

	.table thead tr {
		height: 60px;
	}

	.table thead tr th {
		font-size: 18px;
		text-align: center;
	}

	.table tbody tr {
		height: 60px;
		font-size: 16px;
		background: rgba(245, 245, 245, 0.3);
		border-bottom: 1px solid #E6E6E6;
	}

	.table tbody tr td {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.table tbody tr td:nth-of-type(1) {
		padding-left: 20px;
	}
</style>
<style type="text/css">
	.news-list .ant-tabs-bar {
		border: none !important;
	}

	.news-list .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
		height: auto;
	}

	.news-list .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
		font-size: 20px;
		margin-left: 10px;
		margin-right: 10px;
		color: #666666;
		height: auto;
		padding: 6px 20px;
		background: none;
		border: none;
	}

	.news-list .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
		border: none !important;
		color: #FFFFFF;
		background-color: #13B8EE;
		border-radius: 8px 8px 0px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/property/property.vue